module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-3.59ef6f06.svg";